/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
export const cardLinkedStyle = {
  card: {
    maxWidth: "450px",
    height: "100%",
    marginRight: "auto",
    marginLeft: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  media: {
    // ⚠️ object-fit is not supported by IE11.
    objectFit: "cover",
    height: "200px",
  },
  headline: {
    minHeight: "42px",
  },
  teaserText: {
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  cardActions: {
    justifyContent: "flex-end",
  },
};
